import { FileRules } from '../model/file.rules';

/** Papéis do usuário SOBRE a submissão em questão. */
export interface FileRuleViewer {
  isAuthor: boolean;
  isChair: boolean;
  isReviewer: boolean;
  isSessionChair: boolean;
}

/**
 * A regra de arquivo (slot da trilha) deve aparecer para este usuário?
 *
 * Fonte ÚNICA da decisão. Antes existia só dentro do `file-rules-card`
 * (`showfile`), e os cards da lista não aplicavam nada: listavam todas as
 * regras da trilha. O revisor e o coordenador de sessão viam a label de
 * arquivos marcados como invisíveis para eles e, como o backend corretamente
 * não envia o arquivo, o pill exibia "arquivo ausente" (issue #2381).
 *
 * UNIÃO de papéis, não primeiro-match: papéis no JEMS são acumulativos, então
 * a regra aparece se QUALQUER papel do usuário a autoriza. Um coordenador de
 * sessão que também revisa precisa ver o que `visibleReviewer` libera, mesmo
 * que `visibleSessionChair` seja falso.
 *
 * Sem papel restritivo aplicável → visível. É decisão deliberada do projeto
 * (visibilidade permissiva); quem restringe de verdade é o backend, que não
 * envia o arquivo.
 */
export function isFileRuleVisible(rule: FileRules, viewer: FileRuleViewer): boolean {
  // Autor e chair veem tudo.
  if (viewer.isChair || viewer.isAuthor) { return true; }

  const roleVisibilities: boolean[] = [];
  if (viewer.isSessionChair) { roleVisibilities.push(rule.visibleSessionChair); }
  if (viewer.isReviewer) { roleVisibilities.push(rule.visibleReviewer); }

  if (roleVisibilities.length === 0) { return true; }
  return roleVisibilities.some(visible => visible);
}
